export default __webpack_public_path__ + "static/media/property_639.59d20787.png";